<template>
  <v-container fluid>
    <a name='access'></a>
    <h2><a href='#access'>Access</a></h2>
    <v-container>
      <div class='caution'>
        <div class='caution_title'>
          参加登録について
        </div>
        <div class='caution_message'>
          当日お越しになる方は、事前に参加登録をお願いいたします。<br />
          受付にて確認させていただきます。<br />
          <br />
          <a href='https://connpass.com/event/102650/' target='_blank' class='secondary--text'>https://connpass.com/event/102650/</a>
        </div>
      </div>

      <hr />

      <v-layout row wrap>
        <v-flex class='map_info' xs12 sm8>
          <div class='map_info_building'>
            株式会社インターネットイニシアティブ
          </div>
          <div class='map_info_address'>
            東京都千代田区富士見2-10-2 飯田橋グラン・ブルーム<br />
            2F オフィスロビー IIJゲート前<br />
          </div>
          <div class='map_info_description'>
            入場時はconnpass発行の受付票の提示をお願いいたします。<br />
            ※印刷する必要はございません。<br />
          </div>
        </v-flex>
        <v-flex class='map_link' xs12 sm4>
          <a class='map_link_container' href='https://goo.gl/maps/GtmVcM6Vudz' target='_blank'>
            GoogleMapで見る
          </a>
        </v-flex>
      </v-layout>

      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.108790512818!2d139.74167621525936!3d35.698940380190045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1526bba6d605c7df%3A0xc551410529c0584c!2z77yI5qCq77yJ44Kk44Oz44K_44O844ON44OD44OI44Kk44OL44K344Ki44OG44Kj44OW!5e0!3m2!1sja!2sjp!4v1537170067494" width="100%" height="450" frameborder="0" style="border:0" class='map_thumb' allowfullscreen></iframe>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'eventmap',
  props: {}
}
</script>

<style scoped>
  .map_info {
    padding-left: 20px
  }

  .map_info_building {
    font-weight: bold;
  }

  .map_info_address,
  .map_info_description {
    margin-top: 1rem;
    font-size: 0.8rem;
  }

  .map_thumb {
    margin-top: 2rem;
  }

  .map_link_container {
    padding: 10px;
    border: solid 1px rgb(16, 93, 165);
    color: rgb(16, 93, 165);
    background-color: white;
    display: block;
    text-decoration: none;
    text-align: center;
  }
</style>
